import type { ReactNode } from 'react';
import { Pressable } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { IconArrowLeft } from '@tabler/icons-react-native';
import { Column, Row } from 'app/design/primitives/box';
import { SearchInput } from 'app/design/primitives/input/search';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

export function CatalogSearchHeader({
  onBack,
  onSearch,
  search,
  filters,
}: {
  onBack: () => void;
  onSearch: (query: string) => void;
  search: string;
  filters: ReactNode;
}) {
  const insets = useSafeAreaInsets();
  return (
    <Column zIndex={3} backgroundColor="page" style={{ paddingTop: insets.top }}>
      <Row
        gap="spacing.general.x3"
        alignItems="center"
        paddingHorizontal="spacing.general.x3"
        paddingVertical="spacing.general.x2"
      >
        <Pressable onPress={onBack} testID="catalog-back" hitSlop={8}>
          <IconArrowLeft strokeWidth={ICON_STROKE_WIDTH} />
        </Pressable>
        <Column flex={1} style={{ minWidth: 0 }}>
          <SearchInput initialValue={search} onSubmit={onSearch} fieldHeight={48} />
        </Column>
        {filters}
      </Row>
    </Column>
  );
}
